import {catalogQueryControls, normalizeCatalogQuery} from '~/utils/catalog-query.mjs';

function queryError(error:any) {
    const messages:any = {
        invalid_page: 'Некорректный номер страницы.',
        invalid_sort: 'Некорректная сортировка.',
        invalid_search: 'Некорректные параметры поиска.',
        invalid_filter: 'Некорректные параметры фильтра.',
    };
    return createError({statusCode: 400, message: messages[error?.code] || 'Некорректные параметры каталога.'});
}
export async function useCatalogQuery(category:any) {
    const route = useRoute();
    try { catalogQueryControls(route.query); } catch (error) { throw queryError(error); }
    const result = await useGetCategoryFiltersQuery({variables: computed(() => ({where: {category: unref(category)}}))});
    if (result.error.value) throw createError({statusCode: 503, message: 'Не удалось загрузить фильтры каталога.'});
    const query = computed(() => {
        const data = result.data.value;
        const names = [...(data?.uogorod_seed_specs || []), ...(data?.uogorod_seed_params || [])].map((item:any) => item.name);
        try { return normalizeCatalogQuery(route.query, names); } catch (error) { throw queryError(error); }
    });
    // Validate before the listing query is sent, including on the server.
    query.value;
    return {query, data: result.data, fetching: result.fetching};
}
